import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { setCategoriesCounter } from '../actions/events'
import sortBy from 'lodash/sortBy'
import { push } from 'connected-react-router'
import { addSearchCategory } from '../actions/search'
import MostViewedButton from '../components/most-viewed-button'

class MostViewedContainer extends React.Component {
  componentDidMount() {
    const catCounter = this.props.categoriesCounter || []
    if (
      catCounter.categories.length === 0 ||
      catCounter.expires.isAfter(moment())
    ) {
      this.props.dispatch(setCategoriesCounter(this.countCategoriesCounter()))
    }
  }

  countCategoriesCounter = () => {
    const categoriesCounter = {}
    this.props.events.forEach(e => {
      e.category.split('-').forEach(cat => {
        if (categoriesCounter[cat]) {
          categoriesCounter[cat]++
        } else {
          categoriesCounter[cat] = 1
        }
      })
    })

    const ret = { expires: moment().add(1, 'day'), categories: [] }
    Object.entries(categoriesCounter).forEach(([category, n]) => {
      ret.categories.push({ category, n })
    })

    return ret
  }

  render() {
    const { dispatch } = this.props
    const topFive = sortBy(this.props.categoriesCounter.categories, ['n'])
      .slice(-4)
      .map(e => e.category)

    const topFiveButtons = topFive
      ? topFive.map(cat => (
          <MostViewedButton
            key={cat}
            text={cat}
            onClick={() => {
              dispatch(addSearchCategory(cat, true))
              dispatch(push('/events'))
            }}
          />
        ))
      : []

    return <div>{topFiveButtons}</div>
  }
}

export default connect(state => ({
  events: state.events.events,
  categoriesCounter: state.events.categoriesCounter
}))(MostViewedContainer)
